import Home from './components/home/Home'
import LifestyleChanging from './components/lifestyle-changing/LifestyleChanging'
import DrugTherapy from './components/drug-therapy/DrugTherapy'

export const routes = [
  { path: '/', component: Home },
  { path: '/lifestyle', component: LifestyleChanging },
  { path: '/drug-therapy', component: DrugTherapy },
  { path: '/drug-therapy/:risk', component: DrugTherapy }
]
